import type { ExtensionModuleActionHandler } from '@atlaskit/editor-common/extensions/extension-manifest';

import type { LegacyMacroManifest } from './extensionTypes.ts';
import { OfficeMacroExperienceTrackerSupport } from './OfficeMacroExperienceTrackerSupport.ts';

const isOfficeMacroMetricsEnabled = (macro: LegacyMacroManifest): boolean => {
	try {
		return OfficeMacroExperienceTrackerSupport.isTrackable({ macroName: macro.macroName });
	} catch {
		return false;
	}
};

const safelyRunOfficeMacroTelemetry = (track: () => void): void => {
	try {
		track();
	} catch {
		// Telemetry must never block or alter macro insertion behaviour.
	}
};

export const withOfficeMacroExperience = (
	macro: LegacyMacroManifest,
	action: ExtensionModuleActionHandler,
): ExtensionModuleActionHandler => {
	if (!isOfficeMacroMetricsEnabled(macro)) {
		return action;
	}

	return async (extensionAPI) => {
		const data = { macroName: macro.macroName };
		safelyRunOfficeMacroTelemetry(() => OfficeMacroExperienceTrackerSupport.start(data));

		let result;
		try {
			result = await action(extensionAPI);
		} catch (error) {
			safelyRunOfficeMacroTelemetry(() =>
				OfficeMacroExperienceTrackerSupport.fail(
					error instanceof Error ? error : new Error('Office macro action failed'),
				),
			);
			throw error;
		}

		safelyRunOfficeMacroTelemetry(() => OfficeMacroExperienceTrackerSupport.succeed());
		return result;
	};
};
